import * as React from "react";
import { useBloomreachProductRoutes } from "@grandvisionhq/bloomreach";
import { LinkGroup } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
const categories = [
  {
    icon: "glasses-futuristic",
    label: "facets.productType.sunglasses",
    productRouteKey: "Sunglasses"
  },
  {
    icon: "glasses",
    label: "facets.productType.frames",
    productRouteKey: "Frames"
  },
  {
    icon: "lens",
    label: "facets.productType.contactlenses",
    productRouteKey: "Contact-lenses"
  },
  {
    icon: "solution",
    label: "facets.productType.solutions",
    productRouteKey: "Solutions"
  },
  {
    icon: "store-eye-test",
    label: "facets.productType.readyReaders",
    productRouteKey: "Ready-readers"
  },
  {
    icon: "shopping-bag-alt",
    label: "facets.productType.accessories",
    productRouteKey: "Accessories"
  }
];
const CategoryGroup = () => {
  const [, productRoutes] = useBloomreachProductRoutes();
  const { getLabel } = useIntl();
  const links = React.useMemo(
    () => categories.reduce((acc, category) => {
      const url = productRoutes[category.productRouteKey];
      if (!url) {
        return acc;
      }
      const { icon, label } = category;
      return [
        ...acc,
        {
          icon,
          label: getLabel(label),
          url
        }
      ];
    }, []),
    [getLabel, productRoutes]
  );
  if (!links.length) {
    console.warn("CategoryGroup cannot render: it requires at least one category");
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, null, getLabel("account.profile.categoryGroup.title")), /* @__PURE__ */ React.createElement(LinkGroup, { links }));
};
export {
  CategoryGroup as default
};
//# sourceMappingURL=CategoryGroup.js.map
